<script>
    import { onMount } from "svelte";
    import { user, _sendEmailVerification, refresh } from "../../firebase/auth";

    onMount(async () => {
        refresh()
    })

    function resendVerification (e) {
        e.preventDefault();
        _sendEmailVerification()
        .then(() => {
            alert("Die Verfifizierungsmail wurde erneut zugesandt, je nach Provider kann es einige Minuten dauern, bis sie ankommt.")
        })
    }
</script>

{#if $user}
    <span>{$user.email} <i class="icon-ok-circled {$user.emailVerified?"verified":"unverified"}"></i></span>
    {#if !$user.emailVerified}
        <div class="verification-required">
            <span>Die E-Mail-Adresse ist noch nicht verifiziert. Klicke bitte auf den Link in der Verifizierungsmail. </span><a href on:click={resendVerification}>(Verifizierungsmail neu senden)</a>
        </div>
    {/if}
{/if}

<style>
    .unverified {
        color: rgb(255, 166, 0);
    }
    
    .verified {
        color: green;
    }

    .verification-required {
        margin: 1rem 0;
        border-left: 5px solid rgb(255, 166, 0);
        padding: 0.5rem 1rem;
        background-color: rgb(255, 231, 185);
    }
</style>